
@if (exhibition) {
  @let eventName = exhibition.eventName;
  
  @let eventTestId = 'event-' + exhibition.id;

  <ls-card
    [attr.data-testid]="eventTestId"
    [size]="'lg'"
  >
    @if (exhibition.eventLogo) {
      <div class="exhibition-image-wrapper flex align-items-center justify-content-center">
        <img
          class="exhibition-image pointer-events-none border-round-lg"
          [src]="exhibition.eventLogo"
          [alt]="'a11y.home.exhibition-card.image' | translate: { eventName }"
        />
      </div>
    }

    <div class="exhibition-info-wrapper flex flex-column justify-content-center p-x-4 sm:justify-content-end sm:p-6">
      @if (eventName) {
        <h3 class="event-name" [id]="exhibition.id">
          {{ eventName }}
        </h3>
      }

      <p class="event-duration text-xs font-semibold uppercase">
        @if (exhibition.startDate | localizedDate: 'dd. MMM y'; as exhibitionStartDate) {
          <time [dateTime]="exhibitionStartDate">
            {{ exhibitionStartDate }}
          </time>
        }

        @if (exhibition.endDate | localizedDate: 'dd. MMM y'; as exhibitionEndDate) {
          -
          <time [dateTime]="exhibitionEndDate">
            {{ exhibitionEndDate }}
          </time>
        }
      </p>

      <a
        [attr.aria-label]="'a11y.home.exhibition-card.link' | translate: { eventName }"
        [routerLink]="['/' + WebShopRoute, exhibition.id]"
      ></a>
    </div>

    <i class="las la-angle-right text-lg sm:hidden"></i>
  </ls-card>
}
